<template>
  <div>
    <img class="img" src="images/activity/kindergarten/banner1.jpg" alt="" />
    <button @click="clickHandler" class="btn" :class="{ disable: !verify }">{{ !verify ? '您已' : '' }}领取课程及VIP</button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty } from 'lodash';
export default {
  data() {
    return {
      verify: false,
    };
  },
  async activated() {
    if (this.isLogin) {
      let result = await this.$api.payment_v1_kindergarten_user_info_verify_get();
      this.verify = !result;
    }else{
      this.verify = true;
    }
  },
  created() {
    if (this.isNative && !this.isLogin) {
      this.login();
    }
  },
  methods: {
    login() {
      if (this.isNative) {
        this.$store.dispatch('externalInterface/navigateTo', {
          name: 'login',
        });
      } else {
        this.$router.push('/account/login-bySMS');
      }
    },
    clickHandler() {
      if (this.isNative) {
        if (!this.isLogin) {
          this.login();
          return;
        } else {
          if (this.verify) {
            this.$router.push('detail');
          }
        }
      } else {
        location.href = this.downloadPath;
      }
    },
  },
  computed: {
    ...mapGetters({
      isNative: 'externalInterface/isNative',
      downloadPath: 'externalInterface/downloadApp',
      userInfo: 'auth/userInfo',
      isVisitor: 'auth/isVisitor',
    }),
    isLogin() {
      return !this.isVisitor && !isEmpty(this.userInfo);
    },
  },
};
</script>

<style scoped>
.btn {
  position: fixed;
  bottom: 0;
  display: block;
  width: 100vw;
  height: 52px;
  background: #74b3fa;
  border-radius: 16px 16px 0px 0px;
  text-align: center;
  line-height: 52px;
  font-size: 16px;
  color: #fff;
}
.btn.disable {
  background: #cccccc;
}
.img {
  display: block;
  width: 100vw;
}
</style>
